//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useEffect, useContext, useState, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { CSVLink } from "react-csv";
import * as moment from "moment";

// custom pages
import Context from "context/context";
import mpc from "apis/mpc/mpc";
import product from "apis/Product/product";
import { mpcStyles } from "./styles";
import useDebounce from "helpers/useDebounce";
import Loader from "components/Loader/Loader";
import { exportHeaders } from "./export";
import searchIcon from "assets/img/Search_Icon.png";
import audit from "apis/audit/audit";
import access from "config/access";
import HistoryTable from "components/Table/History/HistoryTable";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Table from "components/Table/Table";
import Button from "@material-ui/core/Button";
import InputAdornment from "@material-ui/core/InputAdornment";
import Grid from "@material-ui/core/Grid";
import FilterListIcon from "@material-ui/icons/FilterList";
import Card from "@material-ui/core/Card";
import Badge from "@material-ui/core/Badge";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import Dialog from "@material-ui/core/Dialog";

// material-ui icons
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import MenuIcon from "@material-ui/icons/Menu";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import HistoryIcon from "@material-ui/icons/History";

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      marginTop: 0,
    },
  },
})(TextField);

const GlobalCss = withStyles({
  "@global": {
    ".MuiOutlinedInput-root": {
      borderRadius: 20,
      marginTop: 0,
    },
    '.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: 0,
    },
  },
})(() => null);

export default function Locations(props) {
  const { state, dispatch } = useContext(Context);
  const { getProduct,search,productFilter,productExport } =product();
  const classes = mpcStyles();

  const [productData, setProductData] = useState([]);
  const [salesCategory, setSalesCategory] = useState([]);
  const [org, setOrg] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [filterCard, setFilterCard] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState({});
  const [selectedSales, setSelectedSales] = useState({});
  const [exportData, setExportData] = useState([]);
  const [response, setResponse] = useState({
    filter: false,
  });
  const [searchValue, setSearchValue] = useState("");
  const searchBounceValues = useDebounce(searchValue);
  const [isLoading, setIsLoading] = useState(false);

  const [states, setstates] = useState({
    filter: false,
    salesCategory: "",
    redemptionFrom: null,
    redemptionTo: null,
    orgName: "",
    isActive: "",
    historyLoader: false,
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { historyLoader } = states;

  const history = useHistory();
  const location = useLocation();

  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Products"],
    });
  }, []);

  // handling api calls
  useEffect(() => {
    if (state.userInfo && Object.keys(state.userInfo).length > 0) {
      states.filter
        ? handleFilter()
        : searchValue.length > 0
          ? handleSearch()
          : handleGetProduct();
    }
  }, [state.userInfo, offset]);

  // mpc api func
  const handleGetProduct = async () => {
    try {
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await getProduct(values);
      if (res) {
        setProductData(res.data);
        setCount(res.count);
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };





  // handling search api
  useEffect(() => {
    let offsetValue = location?.state?.offset;
    if (searchBounceValues && searchBounceValues.length > 0) {
      handleSearch();
    } else if (offsetValue) {
      setOffset(offsetValue);
      location.state = undefined;
    } else {
      setOffset(1);
    }
  }, [searchBounceValues]);

  // search api func
  const handleSearch = async () => {
    setStates({
      filter: false,
    });
    setResponse({ ...response, filter: false });
    setFilterCard(false);
    try {
      let values = {
        searchValue: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await search(values);
      dispatch({ type: "SET_LOADING", payload: false });
      if (res) {
        setProductData(res.data);
        setCount(res.count);
        return;
      }
      setProductData([]);
    } catch (e) {
      dispatch({ type: "SET_LOADING", payload: false });
      console.log({ e });
    }
  };

  // filter api func
  const handleFilter = async () => {
    setStates({ filter: true });
    setSearchValue("");
    try {
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
    
      if (typeof states.isActive === "boolean") {
        values = { ...values, isActive: states.isActive };
      }
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await productFilter(values);
      // console.log(res,"hhhhhh")
      if (res) {
        setProductData(res.data);
        setCount(res.count);
        setFilterCard(false);
        setResponse({ filter: true });
        dispatch({ type: "SET_LOADING", payload: false });
      } else {
        setFilterCard(false);
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // export api function
  const handleExport = async () => {
    let values = {};
    if (searchValue) {
      values = { ...values, searchValue };
    }

    // if (typeof states.isActive === "boolean") {
    //   values = { ...values, isActive: states.isActive };
    // }
   
   
    dispatch({ type: "SET_LOADING", payload: true });
    setIsLoading(true);
    let res =await  productExport(values)
    if (res && res.data) {
console.log("inside")
      setExportData(res.data.map(obj => {
        return {
          ...obj,
          product_code: obj.product_code? obj?.product_code+ String.fromCharCode(8203):"-",
          product_primary_class_id: obj.product_primary_class_id?obj?.product_primary_class_id + String.fromCharCode(8203):"-",
          primary_majorsubmajor_class_code: obj.primary_majorsubmajor_class_code?obj?.primary_majorsubmajor_class_code + String.fromCharCode(8203):"-",
          primary_major_class_code: obj.primary_major_class_code?obj?.primary_major_class_code + String.fromCharCode(8203):"-",
          is_active:obj?.is_active==1?"Active":"Inactive"
        }
      }));
      dispatch({ type: "SET_LOADING", payload: false });
      setIsLoading(false);
      if (res.data.length === 0) {
        toast.success("No data found", { toastId: "no-report-date" });
        return false;
      }
      return true;
    }
  };
  const tableHeading = [
    "Product Code",
    "Product Short Description",
    "Product Primary Class Id",
    "Product Brand Name Code",
    "Status",
    "View detail"
  ];

  

  const invalidChar = ['~', '`', '!', '#', '$', '%', '^', '*', '(', ')', '_', '+', '=', '', ';', ':', '<', '.', '>', '?', '|', '[', ']', '{', '}', '"', "'"]

  const blockInvalidChar = e => invalidChar.includes(e.key) && e.preventDefault();

  return (
    <React.Fragment>
      <GlobalCss />
      <Grid
        container
        spacing={0}
        onClick={() => {
          filterCard == true && setFilterCard(false);
        }}
      >
        {window.innerWidth < 600 && (
          <Grid xs={12}>
            <IconButton
              style={{ position: "absolute" }}
              onClick={() => {
                dispatch({ type: "SET_SIDEBAR", payload: true });
              }}
            >
              <MenuIcon />
            </IconButton>
            <span className={classes.headerText}>Product</span>
          </Grid>
        )}
        <Grid item xs={12} style={{ display: "flex", alignItems: "center" }}>
          <div style={{ flex: 0.99 }}>
          <CssTextField
              placeholder="Search for Product Code or Short Description or Primary Class Id"
              type={"text"}
              variant="outlined"
              onKeyDown={blockInvalidChar}
              className={classes.searchInput}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {searchValue.length > 0 ? (
                      <CloseOutlinedIcon
                        className={classes.searchInputIcon}
                        onClick={() => {
                          setSearchValue("");
                          setOffset(1);
                          handleGetProduct();
                        }}
                      />
                    ) : (
                      <img
                        src={searchIcon}
                        alt=""
                        width="20px"
                        className={classes.searchInputIcon}
                      />
                    )}
                  </InputAdornment>
                ),
              }}
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
                setOffset(1);
                if (e.target.value.length == 0) {
                  handleGetProduct();
                }
              }}
              onClick={() => {
                setOffset(offset);
              }}
            />
            {/* <Button
              className={`${classes.filterBtn} dash-1-filter-btn`}
              onClick={() => {
                setFilterCard(!filterCard);
                if (!states.filter) {
                  setStates({
                    salesCategory: "",
                    redemptionFrom: null,
                    redemptionTo: null,
                    orgName: "",
                  });
                }
              }}
            >
              Filter
              {response["filter"] && (
                <Badge
                  badgeContent={count == 0 ? null : response["filter"] && count}
                  color="error"
                  classes={{ badge: classes.badge }}
                  max={999999}
                  className={classes.badges}
                ></Badge>
              )}
            </Button> */}
          </div>
          <CSVLink
            id="csv"
            data={exportData}
            headers={exportHeaders.map((head) => head)}
            filename={
              `Product` +
              " " +
              moment(new Date()).format("MM-DD-YYYY,h:mm A") +
              ".csv"
            }
            className={classes.CSVlink}
          />
          {/* <button
            disabled={isLoading}
            className={classes.exportBtn}
            onClick={async () => {
              let res = await handleExport();
              if (res) {
                document.getElementById("csv").click();
              }
            }}
          >
            Export
          </button> */}
        </Grid>
      </Grid>

      {filterCard && (
        <div className={classes.filterCardDiv}>
          <Grid container spacing={0}>
            <Grid item xs={12} style={{ float: "right" }}>
              <Card className={classes.filterCard}>
                <Grid
                  container
                  spacing={2}
                  className={classes.filterCardGridContainer}
                >
                  <Grid item sm={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>Status</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.isActive}
                      onChange={(e) => {
                        setStates({ isActive: e.target.value });
                      }}
                    >
                      <MenuItem value={true}>Active</MenuItem>
                      <MenuItem value={false}>Inactive</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid
                    item
                    sm={2}
                    xs={12}
                    className={classes.filterCardBtnGrid}
                  >
                    <Grid container spacing={0}>
                      <Grid item xs={12}>
                        <Button
                          className={classes.filterCardApplyBtn}
                          onClick={() => {
                            if (
                              typeof states.isActive !== "boolean"
                            ) {
                              toast.error("Please select atleast one field.");
                              return;
                            }
                            if (!states.redemptionTo && states.redemptionFrom) {
                              toast.error("Please select To column");
                              return;
                            }
                            if (states.redemptionTo && !states.redemptionFrom) {
                              toast.error("Please select From column");
                              return;
                            }
                            handleFilter();
                            setCount(0);
                            setOffset(1);
                            setResponse({ filter: false });
                          }}
                        >
                          Apply
                        </Button>
                      </Grid>
                      {states.filter && (
                        <Grid item xs={12}>
                          <Button
                            className={classes.filterCardResetBtn}
                            onClick={() => {
                              setStates({
                                filter: false,
                                salesCategory: "",
                                redemptionFrom: null,
                                redemptionTo: null,
                                orgName: "",
                                isActive: "",
                              });
                              setOffset(1);
                              setFilterCard(false);
                              setSelectedOrg({});
                              setSelectedSales({});
                              handleGetProduct();
                              setCount(0);
                              setResponse({ filter: false });
                            }}
                          >
                            Reset
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </div>
      )}
      <Loader Loading={state.loading} top={"15%"}>
        <Grid container style={{ marginTop: 22 }}>
          <Grid item xs={12} sm={12} lg={12}>
            <div className={classes.tableDiv}>
              <Table
                headings={tableHeading.map((i) => (
                  <div
                    className={i === "Org name" ? classes.orgNameColumn : null}
                  >
                    {i}
                  </div>
                ))}
                data={productData.map((p, i) => [
                  p?.product_code,
                  p?.product_short_description,
                  p?.product_primary_class_id,
                  p?.product_brand_name_code,
                  [
                    p?.["is_active"] ? (
                      <span style={{ color: "green" }} key={i}>
                        Active
                      </span>
                    ) : p?.["is_active"] != null ? (
                      <span style={{ color: "red" }} key={i}>
                        InActive
                      </span>
                    ) : null,
                  ],
                  [
                    <RemoveRedEyeIcon
                      key={i}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        history.push("/dashboard/productdetail", {
                          ProductId: p?.product_code,
                          offset,
                        });
                      }}
                    />,
                  ]
                ])}
                offset={offset}
                count={
                  (count / 10) % 1 == 0
                    ? Math.floor(count / 10)
                    : Math.floor(count / 10 + 1)
                }
                handlePagination={handlePagination}
              />
            </div>
          </Grid>
        </Grid>
      </Loader>

     
    </React.Fragment>
  );
}
